import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';
import { ArrowLeft, FileDown } from 'lucide-react';
import { Navbar, Footer } from '@/components/Layout';
import { PilotForm } from '@/components/spec/PilotForm';

const STEPS = [
  'Cancellations only, for 30 days: orders not yet shipped, and bookings or subscriptions inside your cancellation window.',
  'Every request gets one claim ID, so repeats join the existing case instead of opening new tickets.',
  'You give the same answer until your next update time, and decide every case under your own policy.',
  'Customers can contest a decision once, and a person on your team decides it.',
  'Customers who call or chat without an agent get the same claim ID, status, and timing.',
];

export default function PilotSignup() {
  return (
    <div className="min-h-screen bg-[#050505] text-white" data-testid="pilot-signup-page">
      <Helmet><title>Join the 30-Day Cancellation Pilot | Kojiru</title></Helmet>
      <Navbar />
      <main className="pt-28 pb-20 px-6">
        <div className="container mx-auto max-w-3xl">
          <Link to="/specs/claim-records" className="inline-flex items-center gap-1.5 text-xs text-gray-500 hover:text-white transition-colors mb-8" data-testid="pilot-back-link"><ArrowLeft className="w-3.5 h-3.5" /> Claim Records</Link>
          <div className="text-xs uppercase tracking-widest text-amber-300 mb-3">Claim Records · Draft 0.4 · Free pilot</div>
          <h1 className="text-4xl sm:text-5xl font-bold leading-tight mb-4" data-testid="pilot-title">Join the 30-day cancellation pilot</h1>
          <p className="text-base text-gray-400 leading-relaxed mb-6">For merchants getting cancellation requests from AI agents. Try one claim ID, one case, and one fair contest on cancellations only, and measure what changes.</p>
          <ol className="space-y-2 text-sm text-gray-300 list-decimal pl-5 mb-6" data-testid="pilot-steps">
            {STEPS.map((s) => <li key={s}>{s}</li>)}
          </ol>
          <a href="/downloads/kojiru-claim-records-pilot-guide-cancellation.pdf" target="_blank" rel="noopener noreferrer" className="flex sm:inline-flex items-center gap-2 text-sm text-amber-300 hover:text-amber-200" data-testid="pilot-guide-link"><FileDown className="w-4 h-4" /> Read the pilot guide (PDF)</a>
          <a href="/downloads/kojiru-claim-records-pilot-results-template.xlsx" download className="sm:ml-6 mt-2 sm:mt-0 flex sm:inline-flex items-center gap-2 text-sm text-amber-300 hover:text-amber-200" data-testid="pilot-results-template-link"><FileDown className="w-4 h-4" /> Monthly results template (spreadsheet)</a>
          <PilotForm />
          <p className="mt-6 text-xs text-gray-500 max-w-3xl" data-testid="pilot-fine-print">Kojiru publishes the text only. It operates no service, receives no data, decides no claims, and makes no promise about results. Your results are yours, and sharing them is optional. Not legal advice.</p>
        </div>
      </main>
      <Footer />
    </div>
  );
}
